import React, { Component } from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-1002">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-1003">
      <span className="block text-sm font-normal mb-1" data-id="element-1004">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-1005">Start de cursus nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-1006" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-1007">
    <h3 className="text-[#5ce0d2] font-extrabold text-xl md:text-2xl mb-1 uppercase tracking-wide" data-id="element-1008">
      Liefdevol Communiceren
    </h3>
    <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-1009">
      Pakket Actie
    </h2>

    <div className="mb-6" data-id="element-1010">
      <img src="https://cdn.magicpatterns.com/uploads/sZnnt8dxKLASfHTcPAVy58/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-1011" />
    </div>

    {/* What's included */}
    <div className="text-left space-y-2 mb-6 bg-[#faf5eb] rounded-lg p-4" data-id="element-1012">
      <div className="flex items-start gap-2" data-id="element-1013">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1014" />
        <p className="text-sm text-gray-700" data-id="element-1015">
          <span className="font-bold" data-id="element-1016">Liefdevol Communiceren Cursus</span>{' '}
          <span className="text-gray-500" data-id="element-1017">(€197)</span>
        </p>
      </div>
      <div className="flex items-start gap-2" data-id="element-1018">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1019" />
        <p className="text-sm text-gray-700" data-id="element-1020">
          <span className="font-bold" data-id="element-1021">2 gratis aanvullende cursussen</span> naar
          keuze <span className="text-gray-500" data-id="element-1022">(€160)</span>
        </p>
      </div>
      <div className="flex items-start gap-2" data-id="element-1023">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1024" />
        <p className="text-sm text-gray-700" data-id="element-1025">
          <span className="font-bold" data-id="element-1026">Digitaal boek "Wat Zegt Jouw Hond?"</span>{' '}
          <span className="text-gray-500" data-id="element-1027">(€44)</span>
        </p>
      </div>
    </div>

    <div className="text-gray-500 text-base mb-1" data-id="element-1028">
      Totale waarde: <span className="line-through" data-id="element-1029">€401</span>
    </div>
    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-1030">Nu voor €127</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-1031">(Bespaar €274)</div>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-1032">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-1033" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-1034">
      <p className="flex items-center justify-center gap-1" data-id="element-1035">
        <Lock className="w-4 h-4" data-id="element-1036" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-1037">
        <ShieldCheck className="w-4 h-4" data-id="element-1038" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
const PakketActieSection = () => {
  const cursussen = [{
    title: 'Cursus Uitvallen',
    desc: 'Voor honden die uitvallen naar andere honden of mensen tijdens het wandelen.',
    icon: '🐕'
  }, {
    title: 'Cursus Stress bij Wandelen',
    desc: 'Help je hond ontspannen tijdens elke wandeling, ook in drukke omgevingen.',
    icon: '🚶'
  }, {
    title: 'Cursus Overmatig Blaffen',
    desc: 'Ontdek waarom je hond blaft en hoe je dit op een liefdevolle manier vermindert.',
    icon: '🔊'
  }, {
    title: 'Puppycursus',
    desc: 'Begin je puppy-leven goed met de juiste basis in communicatie en vertrouwen.',
    icon: '🐶'
  }, {
    title: 'Cursus Opspringen',
    desc: 'Leer je hond rustig te begroeten zonder springen, zonder corrigeren.',
    icon: '🦴'
  }, {
    title: 'Cursus Verlatingsangst',
    desc: 'Help je hond ontspannen alleen thuis te zijn, stap voor stap.',
    icon: '🏠'
  }, {
    title: 'Cursus Geluidsangst',
    desc: 'Ondersteun je hond bij vuurwerk, onweer en andere harde geluiden.',
    icon: '⚡'
  }];
  return <section className="bg-[#faf5eb] py-16 md:py-20" data-id="element-1039">
      <div className="max-w-6xl mx-auto px-4" data-id="element-1040">
        <div className="text-center mb-12" data-id="element-1041">
          <span className="inline-block bg-[#e53e3e] text-white text-xs md:text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-1042">
            Pakket Actie - Tijdelijk Aanbod
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-[#1a2b4a] mb-4" data-id="element-1043">
            Dit krijg je allemaal voor{' '}
            <span className="text-[#e53e3e]" data-id="element-1044">€127</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1045">
            Niet alleen de Liefdevol Communiceren Cursus, maar een compleet
            pakket dat jou en je hond op elk vlak ondersteunt - met een totale
            waarde van{' '}
            <span className="font-bold line-through text-gray-500" data-id="element-1046">€401</span>.
          </p>
        </div>

        {/* 3 Components Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-1047">
          {/* 1. Hoofdcursus */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden flex flex-col" data-id="element-1048">
            <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-1049">
              Onderdeel 1
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-1050">
              <img src="https://cdn.magicpatterns.com/uploads/sZnnt8dxKLASfHTcPAVy58/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus" className="w-full h-32 object-contain mb-4" data-id="element-1051" />
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-1052">
                Liefdevol Communiceren Cursus
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-1053">
                De complete online cursus waarin je leert de taal van je hond te
                begrijpen en zelf liefdevol terug te communiceren.
              </p>
              <div className="text-right" data-id="element-1054">
                <span className="text-gray-400 line-through" data-id="element-1055">€197</span>
              </div>
            </div>
          </div>

          {/* 2. Twee cursussen */}
          <div className="bg-white rounded-2xl shadow-md border-2 border-[#ffb800] overflow-hidden flex flex-col relative" data-id="element-1056">
            <div className="bg-[#ffb800] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-1057">
              Onderdeel 2 - Gratis Bonus
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-1058">
              <div className="w-full h-32 flex items-center justify-center mb-4 bg-gradient-to-br from-[#e6f7f5] to-[#faf5eb] rounded-lg" data-id="element-1059">
                <div className="text-5xl" data-id="element-1060">🎁</div>
              </div>
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-1061">
                2 Aanvullende Cursussen naar keuze
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-1062">
                Kies tijdens het afrekenen 2 cursussen uit de lijst hieronder
                die het beste bij jouw situatie passen.
              </p>
              <div className="text-right" data-id="element-1063">
                <span className="text-gray-400 line-through" data-id="element-1064">€160</span>
              </div>
            </div>
          </div>

          {/* 3. Boek */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden flex flex-col" data-id="element-1065">
            <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-1066">
              Onderdeel 3 - Gratis Bonus
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-1067">
              <img src="https://cdn.magicpatterns.com/uploads/6GVCL5WQtpsTAWZp3DJ7Rr/boek_mockup_wat_zegt_jouw_hond_(2).png" alt='Boek "Wat Zegt Jouw Hond?"' className="w-full h-32 object-contain mb-4" data-id="element-1068" />
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-1069">
                Boek "Wat Zegt Jouw Hond?"
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-1070">
                De digitale versie van ons boek over hondentaal. Voor op je
                mobiel, tablet, computer of om uit te printen.
              </p>
              <div className="text-right" data-id="element-1071">
                <span className="text-gray-400 line-through" data-id="element-1072">€44</span>
              </div>
            </div>
          </div>
        </div>

        {/* Choose 2 from 7 */}
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 md:p-10 mb-10" data-id="element-1073">
          <div className="text-center mb-8" data-id="element-1074">
            <h3 className="text-2xl md:text-3xl font-black text-[#1a2b4a] mb-3" data-id="element-1075">
              Kies tijdens het afrekenen 2 cursussen naar keuze
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1076">
              Welke uitdaging ervaar jij met je hond? Tijdens het afrekenen
              krijg je de keuze uit deze 7 cursussen - kies de 2 die jij
              waardevol vindt.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1077">
            {cursussen.map((c, i) => <div key={i} className="bg-[#faf5eb] rounded-xl p-4 border border-gray-100 hover:border-[#5ce0d2] transition-colors flex gap-3 items-start" data-id="element-1078">
                <div className="text-3xl flex-shrink-0" data-id="element-1079">{c.icon}</div>
                <div data-id="element-1080">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-1" data-id="element-1081">
                    {c.title}
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-1082">
                    {c.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <p className="text-center text-sm text-gray-500 mt-6 italic" data-id="element-1083">
            Twijfel je nog? Geen zorgen - je kunt je keuze tijdens het afrekenen
            rustig maken.
          </p>
        </div>

        {/* Summary + CTA */}
        <div className="bg-[#1a2b4a] rounded-2xl p-8 md:p-12 text-center text-white shadow-xl" data-id="element-1084">
          <p className="text-sm uppercase tracking-wider text-[#5ce0d2] font-bold mb-3" data-id="element-1085">
            Het Liefdevol Communiceren Pakket
          </p>
          <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-1086">
            Cursus + 2 vrije cursussen + boek
          </h3>
          <div className="flex flex-col items-center mb-6" data-id="element-1087">
            <span className="text-lg text-gray-400 line-through mb-1" data-id="element-1088">
              Totale waarde €401
            </span>
            <span className="text-5xl md:text-6xl font-black text-[#ffb800]" data-id="element-1089">
              €127
            </span>
            <span className="text-[#5ce0d2] font-bold text-lg mt-1" data-id="element-1090">
              Je bespaart €274
            </span>
          </div>
          <div className="max-w-md mx-auto" data-id="element-1091">
            <CTAButton data-id="element-1092" />
          </div>
          <div className="text-xs text-gray-400 mt-6 flex flex-wrap items-center justify-center gap-4" data-id="element-1093">
            <span className="flex items-center gap-1" data-id="element-1094">
              <Lock className="w-4 h-4" data-id="element-1095" /> 100% veilig afrekenen
            </span>
            <span className="flex items-center gap-1" data-id="element-1096">
              <ShieldCheck className="w-4 h-4" data-id="element-1097" /> 365 dagen geld-terug
            </span>
          </div>
        </div>
      </div>
    </section>;
};
export function LiefdevolCommunicerenACPage() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-1098">
      {/* 1. HEADER */}
      <div className="bg-white py-3 px-4" data-id="element-1099">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1100">
          <div className="flex-1 hidden md:block" data-id="element-1101"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-1102" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-1103">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-1104">
              <Mail className="w-5 h-5 mr-2" data-id="element-1105" />
              Hulp nodig? Mail mij op amee@stresslessdogs.nl
            </a>
          </div>
        </div>
      </div>

      {/* 2. SUB BANNER */}
      <div className="bg-[#EDEDED] text-[#1a2b4a] text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-1106">
        Voor baasjes die eindelijk de verborgen taalbarrière met hun hond willen
        doorbreken (en een echte, diepe band willen opbouwen)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-1107">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-1108">
          Jouw hond is niet 'koppig' of 'ongehoorzaam' - je spreekt zijn taal
          niet. Ontdek hoe je vloeiend de hondentaal leert spreken in 3 stappen.
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-1109">
          Zodat jij je hond écht begrijpt, je probleemgedrag kan stoppen zonder
          straffen of corrigeren en jullie de meest liefdevolle band krijgen die
          je als baasje met je hond kan hebben.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-1110">
          <div className="md:col-span-8" data-id="element-1111">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-1112">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-1113">
                <iframe src="https://player.vimeo.com/video/1099360202?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-1114"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-1115">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-1116">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-1117">
                Wat is de Liefdevol Communiceren Methode?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-1118">
                <p data-id="element-1119">
                  De Liefdevol Communiceren Methode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de verborgen taal van hun hond te
                  leren lezen, te begrijpen en zelf vloeiend terug te spreken.
                </p>
                <p data-id="element-1120">
                  We laten je precies zien hoe jouw hond de hele dag met je
                  communiceert via subtiele lichaamssignalen, en hoe jij op een
                  manier terugpraat die hij van nature begrijpt - zonder dwang,
                  straf of dominantie.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-1121">
                  Zodat jullie relatie niet gebaseerd is op gehoorzaamheid, maar
                  op wederzijds begrip en vertrouwen. (Waardoor je hond naar je
                  gaat luisteren omdat die je begrijpt, je vertrouwt en je
                  respecteert).
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-1122">
            <PricingCard data-id="element-1123" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1124">
        {/* 6. VOOR WIE WERKT DIT */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-1125">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-1126">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-1127">
            Voor alle baasjes die worstelen met gedragsproblemen en het gevoel
            hebben dat ze hun hond niet echt begrijpen:
          </p>
          <ul className="space-y-4" data-id="element-1128">
            {['Het maakt niet uit als je nog nooit eerder iets hebt geleerd over hondentaal of lichaamssignalen.', 'De methode is eenvoudig en direct toepasbaar. Met slechts 30 minuten per dag zie je binnen een week al de eerste verbeteringen, en binnen twee tot vier weken ontstaat er een compleet nieuwe relatie.', 'Geschikt voor honden van alle leeftijden, rassen en formaten.', 'Werkt ook bij angstige honden, overprikkelde honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1129">
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-1130" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-1131">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Desire Stack */}
          <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-1132">
            <h4 className="text-xl font-bold text-[#1a2b4a] mb-4" data-id="element-1133">
              Stel je voor dat je straks…
            </h4>
            <ul className="space-y-3" data-id="element-1134">
              {['Precies weet hoe je je hond op zijn gemak stelt als hij onrustig wordt - zonder te schreeuwen of te corrigeren.', 'Zijn stresssignalen herkent vóórdat het escaleert, zodat je hem kunt geruststellen op het moment dat hij het nodig heeft.', 'Ontspannen kunt wandelen zonder constant alert te zijn op andere honden of mensen.', "Zonder commando's communiceert met je hond, gewoon door je lichaamstaal - en hij begrijpt je meteen.", 'Visite kunt ontvangen zonder dat je hond door het lint gaat of dat jij je moet verontschuldigen.', 'Eindelijk die diepe, rustige band voelt waar je altijd van hebt gedroomd - elke dag opnieuw.'].map((item, i) => <li key={`desire-${i}`} className="flex items-start" data-id="element-1135">
                  <Star className="w-5 h-5 text-[#ffb800] mr-3 flex-shrink-0 mt-0.5" data-id="element-1136" />
                  <span className="text-gray-700 text-lg" data-id="element-1137">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-1138">
          Met de Liefdevol Communiceren Methode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-1139">
          <p data-id="element-1140">
            ...leer je in drie stappen de taal van je hond te lezen én te
            spreken, zodat jullie eindelijk op één lijn zitten en
            gedragsproblemen vanzelf verminderen.
          </p>
          <p data-id="element-1141">
            Waardoor je hond zich begrepen voelt en jullie samenwerking soepeler
            gaat dan je ooit voor mogelijk hield.
          </p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-1142">
            Geen frustratie meer dat je alles hebt geprobeerd maar niets werkt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-1143">
          <img src="https://cdn.magicpatterns.com/uploads/fGHv8ypZfDoYKf4ChjPLqb/IMG-20171008-WA0012.jpg" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-1144" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-1145">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-1146">
            Herken jij dit bij jouw hond?
          </h3>
          <ul className="space-y-4" data-id="element-1147">
            {['Springt tegen visite op, blaft de bezorger af, of wordt helemaal gek als er iemand aan de deur komt', 'Trekt als een bezetene aan de lijn of valt uit naar andere honden tijdens het wandelen', 'Pakt eten van tafel, luistert niet als je hem roept, of negeert je compleet in het park', 'Is constant druk in huis, kan niet tot rust komen op zijn plek, of volgt je overal naartoe', 'Reageert angstig op geluiden, nieuwe plekken of onbekende mensen - en jij weet niet hoe je hem gerust kunt stellen', 'Het gevoel dat je alles al hebt geprobeerd, maar dat jullie nog steeds langs elkaar heen leven', 'Hij vertrouwt je niet echt'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1148">
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-1149" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-1150">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-lg font-bold text-[#1a2b4a]" data-id="element-1151">
            Dan is deze cursus voor jou.
          </p>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-1152">
        <div className="max-w-4xl mx-auto px-4" data-id="element-1153">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-1154">
            <div data-id="element-1155">
              <p className="text-[#5ce0d2] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-1156">
                Liefdevol Communiceren
              </p>
              <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-4" data-id="element-1157">
                Pakket Actie
              </h2>
              <div className="text-gray-500 text-base mb-1" data-id="element-1158">
                Totale waarde: <span className="line-through" data-id="element-1159">€401</span>
              </div>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-1160">
                Nu voor €127
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-1161">
                (Bespaar €274)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-1162">
                Start met het Liefdevol Communiceren Pakket voor €127. Inclusief
                2 gratis aanvullende cursussen naar keuze en het digitale boek
                "Wat Zegt Jouw Hond?". Per direct toegang.
              </p>
            </div>
            <div data-id="element-1163">
              <CTAButton data-id="element-1164" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-1165">
                <p className="flex items-center justify-center gap-1" data-id="element-1166">
                  <Lock className="w-4 h-4" data-id="element-1167" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-1168">
                  <ShieldCheck className="w-4 h-4" data-id="element-1169" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PakketActieSection data-id="element-1170" />

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-1171">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-1172">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-1173">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-1174">
              Hij luistert wel, maar begrijpt je niet
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-1175">
              <p data-id="element-1176">
                Een commando heeft pas zin als je eerst dezelfde taal spreekt
                als je hond.
              </p>
              <p data-id="element-1177">
                Doe je dat niet, dan blijft er een onzichtbare muur tussen
                jullie staan. Je hond snapt niet wat je tegen hem zegt, en jij
                begrijpt niet waarom. Want jullie spreken letterlijk een andere
                taal.
              </p>
              <p data-id="element-1178">
                Jouw hond communiceert de hele dag subtiele signalen. Dat je die
                soms mist, is niet jouw schuld. De ouderwetse hondenindustrie
                heeft ons decennialang verteld dat honden gewoon moeten
                'luisteren', in plaats van ons te leren hoe we hun taal kunnen
                lezen.
              </p>
              <p data-id="element-1179">
                Oude trainingsmethodes laten je geloven dat je hond 'koppig' of
                'dominant' is als die niet luistert, terwijl jullie in
                werkelijkheid elkaar niet begrijpen. Zodra je weet hoe je op een
                manier communiceert die hij vanuit zijn natuur snapt, valt die
                frustratie direct weg.
              </p>
              <p className="font-medium" data-id="element-1180">
                Daarom moet je eerst de taalbarrière doorbreken. Dit is hoe het
                werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-1181">
              <img src="https://cdn.magicpatterns.com/uploads/43tvVR32w9VpvEgS87mE9U/liefdevol_vergelijking_v4.png" alt="Oude Aanpak vs De Liefdevol Communiceren Methode" className="w-1/2 h-auto object-contain rounded-lg mx-auto" data-id="element-1182" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-1183">
              De taalbarrière doorbreken in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-1184">
              {[{
              title: 'Stap 1: Hondentaal',
              text: 'De eerste stap is de taal van je hond leren. Je hond communiceert de hele dag via subtiele lichaamssignalen. In stap 1 leer je deze signalen herkennen en begrijpen, zodat je eindelijk weet wat je hond je probeert te vertellen.'
            }, {
              title: 'Stap 2: Terugpraten',
              text: 'De tweede stap is zelf in die taal terugpraten. Je leert hoe je met handgebaren en lichaamstaal signalen communiceert op een manier die je hond van nature begrijpt. Geen geschreeuw, geen straffen - gewoon duidelijke, liefdevolle communicatie die hij meteen oppikt.'
            }, {
              title: 'Stap 3: Samenwerken',
              text: 'En dan, als jullie dezelfde taal spreken… Ga je als derde stap écht samenwerken. Niet meer commanderen en gehoorzamen, maar een gelijkwaardige samenwerking gebaseerd op begrip en vertrouwen. Gedragsproblemen lossen zichzelf op, want de oorzaak - miscommunicatie - is verdwenen.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-1185">
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-1186">
                    {i + 1}
                  </div>
                  <div data-id="element-1187">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1188">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-1189">
              Op deze manier kan zelfs een hond die al jaren uitvalt, blaft of
              trekt leren om rustig en ontspannen te zijn - omdat hij zich
              eindelijk begrepen voelt en jij eindelijk begrijpt wat hij nodig
              heeft.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-1190">
              Zonder frustratie, zonder straffen, zonder dominantie.
            </p>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-1191">
              Zo pas je de Liefdevol Communiceren Methode vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-1192">
              De Liefdevol Communiceren Methode is uniek in Nederland.
              Hondenscholen werken nog niet op deze manier. Maar wij vinden dat
              ieder hondenbaasje dat worstelt met de gedragsproblemen van zijn
              hond, of die zijn hond simpelweg beter wilt begrijpen, de kans zou
              moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-1193">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we de drie essentiële stappen in deze aanpak.
              Dit doen we met een rustige uitleg, praktijkvoorbeelden en
              printbaar lesmateriaal.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-1194">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de subtiele lichaamssignalen van je hond en hoe je deze leest, zodat je zeker weet wat hij je probeert te vertellen.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je met handgebaren en je lichaam in hondentaal terugpraat, zodat je hond jou begrijpt en klaar is voor stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe jullie als een team kunnen samenwerken, zodat gedragsproblemen vanzelf verdwijnen.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-1195">
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-1196">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1197">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-1198">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-1199">
            <div className="sticky top-8" data-id="element-1200">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-1201">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-1202">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-1203">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-1204">
                    <img src="https://cdn.magicpatterns.com/uploads/4wUNXnqn4DFV4J3eFkdeE5/lc_book_mockup.png" alt="Liefdevol Communiceren - Cursus" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-1205" />
                    <div data-id="element-1206">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1207">
                        LIEFDEVOL COMMUNICEREN - CURSUS
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1208">
                        Gedetailleerde uitleg van hoe je de verborgen
                        taalbarrière in 3 stappen doorbreekt en een diepe band
                        opbouwt
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-1209">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-1210">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1211" />
                    <div data-id="element-1212">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1213">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1214">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-1215">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Printbare Stappenplannen" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1216" />
                    <div data-id="element-1217">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1218">
                        Printbare Stappenplannen
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1219">
                        Handige, printbare overzichten van alle lichaamssignalen
                        en kalmerende signalen om er altijd bij te kunnen
                        pakken.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-1220">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Levenslange Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-1221" />
                    <div data-id="element-1222">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-1223">
                        Levenslange Toegang
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1224">
                        Je krijgt levenslange toegang tot al het lesmateriaal,
                        inclusief alle toekomstige updates van de cursus.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-1225">
                    RESULTATEN VAN DE METHODE
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-1226">
                    <div style={{
                    padding: '112.5% 0 0 0',
                    position: 'relative'
                  }} data-id="element-1227">
                      <iframe src="https://player.vimeo.com/video/1084988962?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-1228"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-1229">
        <div className="max-w-6xl mx-auto px-4" data-id="element-1230">
          {/* Section headline */}
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-1231">
            RESULTATEN VAN DE METHODE
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-1232">
            Dit is hoe ik hondenbaasjes help om de taalbarrière te doorbreken
            door eerst de hondentaal te leren, dit maakt de verdere samenwerking
            veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-1233">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Liefdevol Communiceren Methode
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-1234">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-1235">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-1236">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-1237">
                  <p className="font-bold" data-id="element-1238">Beste hondenbaasje,</p>
                  <p data-id="element-1239">
                    <strong data-id="element-1240">Van:</strong> Amee de Bruijn
                  </p>
                  <p data-id="element-1241">
                    <strong data-id="element-1242">Re:</strong> De enige manier om gedragsproblemen
                    écht op te lossen, is door de taal van je hond te spreken
                    (en niet door te commanderen).
                  </p>
                  <p data-id="element-1243">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos corrigeren waarmee je gedragsproblemen sneller
                    kunt oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-1244">En dat is niet gek.</p>
                  <p data-id="element-1245">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: commando's, correcties, je hond
                    domineren, of afleiden met snoepjes.
                  </p>
                  <p data-id="element-1246">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-1247">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-1248">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-1249">
                    <strong data-id="element-1250">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Deze verandering vraagt erom dat je anders gaat kijken naar
                    je hond. Op een lievere, empatischere manier waarin je hond
                    geen robot is die zomaar bevelen op zou moeten volgen. Maar
                    meer een volwaardig gezinslid van een gezin waar jij aan het
                    hoofd staat. Als je er niet toe bereid bent zo naar je hond
                    te kijken, dan is deze methode misschien niet voor jou. Met
                    dat gezegd, laat me je laten zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-1251">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-1252">
                    Dit is dezelfde Liefdevol Communiceren Methode die duizenden
                    hondeneigenaren nu gebruiken om onbegrip, irritaties en
                    problemen met hun hond écht op te lossen.
                  </p>
                  <p data-id="element-1253">
                    Hierdoor krijgen zij een ontspannen hond terug, sneller dan
                    ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-1254">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-1255">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-1256">
                    Het is een fundamenteel andere manier van samenleven met je
                    hond. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1257">
                    <li data-id="element-1258">
                      Eindeloze gehoorzaamheidstrainingen die nergens toe
                      leiden.
                    </li>
                    <li data-id="element-1259">
                      Je hond straffen of corrigeren als hij iets 'fout' doet.
                    </li>
                    <li data-id="element-1260">Trucjes om je hond af te leiden met voer.</li>
                    <li data-id="element-1261">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-1262">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met het leren van de taal van de hond zodat jullie
                    elkaar echt gaan begrijpen.
                  </p>
                  <p data-id="element-1263">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-1264">
                    Hoe ik dit ontdekte: De "Muur van Onbegrip" bij mijn klanten
                  </h3>
                  <p data-id="element-1265">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Muur van Onbegrip":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-1266">
                    <p data-id="element-1267">
                      <strong data-id="element-1268">Stap 1:</strong> Ze volgden online adviezen en
                      begonnen met strenge commando's en correcties.
                    </p>
                    <p data-id="element-1269">
                      <strong data-id="element-1270">Stap 2:</strong> De hond luisterde niet, dus ze
                      proberen strenger te zijn. Meer correcties.
                    </p>
                    <p data-id="element-1271">
                      <strong data-id="element-1272">Stap 3:</strong> Na een week leek de hond even te
                      luisteren uit angst. Een klein succes!
                    </p>
                    <p data-id="element-1273">
                      <strong data-id="element-1274">Stap 4:</strong> Maar het streng zijn voelt niet
                      fijn voor het baasje en is niet altijd consistent. Wat
                      weer verwarrend is voor de hond.
                    </p>
                    <p data-id="element-1275">
                      <strong data-id="element-1276">Stap 5:</strong> De hond onderdrukt deels zijn
                      reacties en de hele situatie levert hem stress op.
                    </p>
                    <p data-id="element-1277">
                      <strong data-id="element-1278">Stap 6:</strong> Stress bij de hond bouwt op
                      waardoor hij reactief wordt. Hij reageert ineens heftig op
                      straat, wordt angstig of gaat ander "probleemgedrag"
                      vertonen.
                    </p>
                    <p data-id="element-1279">
                      <strong data-id="element-1280">Stap 7:</strong> Met dit nieuwe gedrag beginnen ze
                      weer bij stap 1 (en voelen zich een slechte baas).
                    </p>
                  </div>
                  <p data-id="element-1281">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-1282">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen en het voelde slecht.
                  </p>
                  <p data-id="element-1283">
                    Ik stond op het punt om te geloven dat sommige honden gewoon
                    onhandelbaar waren en het vak als hondengedragsdeskundige
                    niks voor mij was.
                  </p>
                  <p data-id="element-1284">
                    Maar voordat ik opgaf, kwam ik in aanraking met een nieuwe
                    methode. En deze methode veranderde alles voor mij.
                  </p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-1285">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee de Bruijn" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-1286" />
                    <div data-id="element-1287">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-1288">
                        Mijn naam is Amee, en ik ken de frustratie als baasje.
                      </h3>
                      <div className="space-y-4" data-id="element-1289">
                        <p className="text-sm text-[#5ce0d2] font-bold uppercase tracking-wide" data-id="element-1290">
                          Gediplomeerd Hondengedragsconsultant & Natural Dog
                          Trainer (niveau 5, Calming Signs, 2017)
                        </p>
                        <p data-id="element-1291">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde die ze van hun baasje
                          krijgen nog steeds problemen hebben.
                        </p>
                        <p data-id="element-1292">
                          Eigenaren die alles voor hun hond over hebben, maar
                          waarvan de hond nog steeds niet altijd lekker in zijn
                          vel zit.
                        </p>
                        <p data-id="element-1293">
                          Geen ontspannen wandeling, altijd die knoop in je maag
                          als je een andere hond tegenkomt, reactieve hond die
                          reageert op alles buiten het huis, heftige reactie op
                          visite, en nog meer...
                        </p>
                        <p data-id="element-1294">
                          Na jarenlange ervaring met honderden honden en hun
                          baasjes, en een specialisatie in natuurlijk
                          hondengedrag en hondenlichaamstaal, ontwikkelde ik een
                          methode die niet draait om gehoorzaamheid, maar om
                          wederzijds begrip.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-1295">
                    Keer op keer zag ik dat de standaard aanpak niet echt hielp.
                  </p>
                  <p data-id="element-1296">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen het gedrag niet opgelost met de
                    standaard aanpak die ik toen ook nog toepaste.
                  </p>
                  <p data-id="element-1297">
                    Pas toen we alles loslieten, volledig stopten met
                    conditioneren en begonnen met het echt kijken naar zijn
                    signalen en wat hij nodig had - gebeurde er iets magisch.
                    Het probleemgedrag verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-1298">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-1299">
                    Ongehoorzaamheid was niet het probleem; het was een
                    symptoom.
                  </p>
                  <p data-id="element-1300">En die kijk maakt het verschil in alles dat ik doe.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-1301">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-1302">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "africhters" en je hebt de "liefdevolle
                    hondenouders". Wij van Stressless Dogs zijn dat laatste. Wij
                    geloven dat je als hondenbaasje eigenlijk geen echte "baas"
                    bent over je hond, maar meer een liefdevolle ouder.
                  </p>
                  <p data-id="element-1303">
                    Maar jarenlang was ik ook een africhter. Ik probeerde mijn
                    klanten te helpen door het blaffen, piepen en slopen af te
                    leren...
                  </p>
                  <p data-id="element-1304">
                    Alleen het probleem is niet het gedrag zelf. Het probleem is
                    waar het gedrag vandaan komt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-1305">
                    Het gevaarlijkste advies dat je kunt krijgen, is "strenger
                    en consistent zijn".
                  </p>
                  <p data-id="element-1306">
                    Waarom? Omdat honden wel willen samenwerken, maar vaak niet
                    snappen wat van hen verwacht wordt omdat het baasje
                    verkeerde signalen met zijn lichaam afgeeft.
                  </p>
                  <p data-id="element-1307">Door deze miscommunicatie krijgt de hond stress.</p>
                  <p data-id="element-1308">
                    En deze stress bouwt op en zorgt voor meer probleemgedrag.
                  </p>
                  <p data-id="element-1309">
                    Opgebouwde stress zorgt ervoor dat je hond reactief wordt,
                    sneller blaft naar voorbijgangers, aan de lijn gaat trekken,
                    uitvalt, en meer.
                  </p>
                  <p className="font-bold" data-id="element-1310">
                    Daarom is de oplossing anders dan je denkt.
                  </p>
                  <p className="font-bold" data-id="element-1311">
                    Zodra je de lichaamssignalen van je hond goed begrijpt zie
                    je wat hij denkt, wilt en waar hij stress van krijgt. En als
                    je terug communiceert op een manier die hij van nature
                    begrijpt. Dan raakt je hond veel meer op zijn gemak en zal
                    je zien dat hij naar je luistert.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-1312">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-1313">
                    {[{
                    title: 'Stap 1: Hondentaal',
                    text: 'Leer de subtiele lichaamssignalen van je hond en hoe je ontdekt wat hij je precies probeert te vertellen.'
                  }, {
                    title: 'Stap 2: Terugpraten',
                    text: 'Krijg de tools om in zijn eigen taal terug te communiceren en een sterke, veerkrachtige vertrouwensband te leggen.'
                  }, {
                    title: 'Stap 3: Samenwerken',
                    text: 'Leer hoe je stressvrij en effectief kunt samenwerken, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-1314">
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-1315" />
                        <div data-id="element-1316">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-1317">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-1318">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-1319">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-1320">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-1321">
                    Deze methode is <strong data-id="element-1322">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-1323">
                    Deze methode is <strong data-id="element-1324">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-1325">
                    Als je klaar bent om de cirkel van stress te doorbreken en
                    een diepere band met je hond te krijgen, dan is dit het
                    moment.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-1326">
                    <img src="https://cdn.magicpatterns.com/uploads/7QbopuV5o2pEQqFw8GzzYw/Ontwerp_zonder_titel_(66).png" alt="Amee met hond buiten" className="w-full h-auto object-cover" data-id="element-1327" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-1328">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-1329">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1330">
                  <img src="https://cdn.magicpatterns.com/uploads/7kNRQ43TgkEzcEQikb1C2w/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-1331" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1332">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1333">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-1334">
                    <div className="flex items-start gap-3" data-id="element-1335">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1336" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-1337">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1338">
                      Dit leer je in Stap 1
                    </p>
                    {['Hoezo commanderen geen nut heeft als je niet eerst dezelfde taal spreekt', 'Welke subtiele lichaamssignalen honden gebruiken en wat ze precies betekenen', 'Hoe je de signalen van jouw hond leest zodat je weet wat hij nodig heeft'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-1339">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1340" />
                        <span className="text-sm text-gray-700" data-id="element-1341">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1342">
                      Dit leer je in Stap 2
                    </p>
                    {['Hoe je kalmerende signalen en handgebaren gebruikt om terug te praten', 'Wat je wel, en wat je juist niet moet doen met je lichaamstaal om misverstanden te voorkomen', 'Voorbeeld casus van hond Lemmy en hoe hij van extreem uitvallen naar ontspannen wandelen ging met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe zij hun frustratie in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-1343">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1344" />
                        <span className="text-sm text-gray-700" data-id="element-1345">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1346">
                      Dit leer je in Stap 3
                    </p>
                    {['Effectief samenwerken zodat je op de juiste manier een diepe band opbouwt', 'Drie voorbeeld situaties waarin je de methode in de praktijk brengt'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-1347">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1348" />
                        <span className="text-sm text-gray-700" data-id="element-1349">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-1350">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Masterclass hondengeschiedenis. Ontwikkeling van het diersoort en de ontwikkeling van wetenschappelijke onderzoeken en conclusies over hondengedrag.', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-1351">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1352" />
                        <span className="text-sm text-gray-700" data-id="element-1353">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1354">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-1355">
                    Liefdevol Communiceren Pakket Actie
                  </div>
                  <div className="p-5 text-center" data-id="element-1356">
                    <img src="https://cdn.magicpatterns.com/uploads/oEL2JDeiE1fJbhau44wGFR/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-1357" />
                    <div className="text-gray-500 text-sm" data-id="element-1358">
                      <span className="line-through" data-id="element-1359">€401</span>
                    </div>
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-1360">
                      Slechts €127
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-1361">
                      (Bespaar €274)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-1362">
                      Cursus + 2 vrije cursussen + digitaal boek. Direct
                      toegang.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-1363">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-1364">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-1365">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1366">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1367">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-1368">
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1369">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-1370">
                        <Star className="w-4 h-4 fill-current" data-id="element-1371" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1372" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1373" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1374" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1375" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-1376">
                        "Sinds we de cursus volgen, is de band met Max zoveel
                        sterker geworden. We begrijpen elkaar eindelijk!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-1377">
                        - Lisa & Max
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1378">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-1379">
                        <Star className="w-4 h-4 fill-current" data-id="element-1380" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1381" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1382" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1383" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1384" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-1385">
                        "Ik dacht dat mijn hond gewoon koppig was, maar dankzij
                        Amee zie ik nu dat hij me iets probeerde te vertellen.
                        Een wereld van verschil."
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-1386">
                        - Mark & Bella
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1387">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-1388">
                        <Star className="w-4 h-4 fill-current" data-id="element-1389" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1390" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1391" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1392" />
                        <Star className="w-4 h-4 fill-current" data-id="element-1393" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-1394">
                        "De rust in huis is teruggekeerd. Geen frustratie meer,
                        maar echte samenwerking. Bedankt!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-1395">
                        - Sarah & Luna
                      </p>
                    </div>
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1396">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-1397">
                    Start met het Liefdevol Communiceren Pakket
                  </div>
                  <div className="p-5 text-center" data-id="element-1398">
                    <div className="text-gray-500 text-sm" data-id="element-1399">
                      Totale waarde <span className="line-through" data-id="element-1400">€401</span>
                    </div>
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-1401">
                      Slechts €127 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-1402">
                      (Bespaar €274)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-1403">
                      Inclusief 2 vrije cursussen + digitaal boek "Wat Zegt Jouw
                      Hond?". Direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-1404">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-1405">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1406">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1407">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-1408">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Printbare Stappenplannen',
                    desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen om er altijd bij te kunnen pakken.'
                  }, {
                    title: 'Levenslange Toegang',
                    desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates van de cursus.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-1409">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-1410" />
                        <div data-id="element-1411">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-1412">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-1413">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-1414">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-1415">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-1416">
                    {['1084982139', '1084982111', '1084982084'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-1417">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-[8/9]" title={`Testimonial ${id}`} data-id="element-1418"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-1419">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-1420">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-1421">
                    Start nu met de Liefdevol Communiceren Methode
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-1422">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1423">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-1424" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-1425">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-1426">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-1427">
            <p data-id="element-1428">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €127 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-1429">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-1430">
              Ik geef je 365 dagen om de Liefdevol Communiceren Cursus te
              bekijken en toe te passen.
            </p>
            <p data-id="element-1431">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €127 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-1432">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-1433">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-1434">
          <p className="text-[#5ce0d2] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-1435">
            Liefdevol Communiceren Pakket Actie
          </p>
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-1436">
            Vandaag voor €127
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-1437">
            (Bespaar €274)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/9QvtvBrW74TzrCyCAwHwpa/lc_booklet_mockup.png" alt="Liefdevol Communiceren Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-1438" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-1439">
            Start met het complete Liefdevol Communiceren Pakket voor{' '}
            <span className="line-through" data-id="element-1440">€401</span> slechts €127! Inclusief 2
            gratis cursussen naar keuze en het digitale boek "Wat Zegt Jouw
            Hond?". Direct toegang.
          </p>
          <div className="max-w-md mx-auto" data-id="element-1441">
            <CTAButton data-id="element-1442" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-1443">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-1444">
        <div className="max-w-6xl mx-auto px-4" data-id="element-1445">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-1446">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1447">
            {[{
            title: 'Liefdevol Communiceren Cursus',
            desc: 'Volledige training in hoe je de Liefdevol Communiceren Methode inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/pPc7pHdzhv1XesyMhYPzEV/lc_book_mockup.png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Levenslange Toegang',
            desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Printbare Stappenplannen',
            desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-1448">
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-1449">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-1450">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-1451">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-1452" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-1453">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-1454">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-1455">
        <div className="max-w-md mx-auto" data-id="element-1456">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-1457">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-1458">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-1459">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-1460">
          <div className="flex-1 text-center md:text-left" data-id="element-1461">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-1462">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-1463">
              <strong data-id="element-1464">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-1465">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-1466">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-1467" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-1468">
        <div className="max-w-5xl mx-auto px-4" data-id="element-1469">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-1470">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-1471">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vind je drie uitgebreide modules waarin je alles leert over de Liefdevol Communiceren Methode.'
          }, {
            q: 'Wat is de Liefdevol Communiceren Methode?',
            a: 'Dit is een nieuwe methode waarin je de taalbarrière tussen jou en je hond doorbreekt in plaats van je alleen maar te richten op commanderen. Wij gebruiken deze methode om jaarlijks bij honderden honden gedragsproblemen bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: 'Alles wat je kan vinden gaat alleen maar over gehoorzaamheid en correcties. Met deze methode kijk je naar de taal die je hond spreekt, pak je de miscommunicatie bij de kern aan en ga je daarna pas samenwerken. Op deze manier heb je sneller, beter en blijvend resultaat.'
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de gedragsproblemen van hun hond nu voor eens en altijd willen oplossen en dit op een empatische, liefdevolle manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-1472">
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-1473">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-1474" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-1475">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WANDELINGEN-BEELD */}
      <section className="bg-[#faf5eb] py-12" data-id="element-1476">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-1477">
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium" data-id="element-1478">
            Hoe vaak per dag laat jij je hond uit? Drie keer? Vier keer?
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-1479">
            Dat zijn{' '}
            <span className="font-black text-[#1a2b4a]" data-id="element-1480">
              honderden wandelingen per jaar
            </span>
            . Honderden momenten samen.
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-1481">
            Waarom zouden jullie al die momenten doorbrengen met frustratie en
            spanning, als het ook{' '}
            <span className="text-[#5ce0d2] font-bold" data-id="element-1482">
              ontspannen en verbonden
            </span>{' '}
            kan?
          </p>
          <p className="text-lg text-gray-500 mt-6 italic" data-id="element-1483">
            Eén kleine verandering in hoe jij communiceert, verandert élke
            wandeling. Elke ochtend. Elke avond. Voorgoed.
          </p>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-1484">
        <div className="max-w-md mx-auto" data-id="element-1485">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-1486">
            Start met deze cursus
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-1487">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-1488">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-1489">
          <p className="font-bold text-white mb-8" data-id="element-1490">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-1491">
            <p className="font-bold text-white" data-id="element-1492">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-1493">
              Start met de cursus.
            </a>
          </div>

          <p className="text-justify" data-id="element-1494">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-1495">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-1496">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-1497">
            <img src="https://cdn.magicpatterns.com/uploads/kbsUp8Jcv8Ni5jP2oc579N/Ontwerp_zonder_titel_(70).png" alt="Liefdevol Communiceren Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-1498" />
            <img src="https://cdn.magicpatterns.com/uploads/fnqxQ7hwmYLpvvLjHhPAxX/Ontwerp_zonder_titel_(69).png" alt="Liefdevol Communiceren Cursus" className="w-16 md:w-24 h-auto object-contain" data-id="element-1499" />
            <div data-id="element-1500">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-1501">
                Liefdevol Communiceren Cursus
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-1502">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-1503">
                  €197
                </span>
                €127
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-1504">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}